// extracted by mini-css-extract-plugin
export default {"signInContainer":"formPage_signInContainer__FVbbq","signInPopup":"formPage_signInPopup__8Ftuq","signInBar":"formPage_signInBar__aGLN+","close":"formPage_close__lNHJu"};